exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MetaBlock-d3061984{background:#ebebeb;padding:10px;font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;position:relative}.blockList-7f684ee4{display:flex;margin:40px 0}.blockItem-70a47dbd{flex:1;text-align:center;font-size:16px;cursor:pointer}.blockItem-70a47dbd i{display:block;margin:0 auto;opacity:0.5;transition:opacity 0.15s ease-in-out}.blockItem-70a47dbd:hover i{opacity:1}.adminBlocks-69450814{background:#23abca;text-align:center;display:flex;align-items:center}\n", ""]);

// Exports
exports.locals = {
	"MetaBlock": "MetaBlock-d3061984",
	"blockList": "blockList-7f684ee4",
	"blockItem": "blockItem-70a47dbd",
	"adminBlocks": "adminBlocks-69450814"
};